export const KEPCOPlanTypeStringList = [
  '일반용 전력(갑)I 저압전력',
  '일반용 전력(갑)I 고압A 선택I',
  '일반용 전력(갑)I 고압A 선택II',
  '일반용 전력(갑)I 고압B 선택I',
  '일반용 전력(갑)I 고압B 선택II',
  '일반용 전력(갑)II 고압A 선택I',
  '일반용 전력(갑)II 고압A 선택II',
  '일반용 전력(갑)II 고압B 선택I',
  '일반용 전력(갑)II 고압B 선택II',
  '산업용 전력(갑)I 고압A 선택I',
  '산업용 전력(갑)I 고압A 선택II',
  '산업용 전력(갑)I 고압B 선택I',
  '산업용 전력(갑)I 고압B 선택II',
  '산업용 전력(갑)I 저압전력',
  '산업용 전력(갑)II 고압A 선택I',
  '산업용 전력(갑)II 고압A 선택II',
  '산업용 전력(갑)II 고압B 선택I',
  '산업용 전력(갑)II 고압B 선택II',
  '일반용 전력(을) 고압A 선택I',
  '일반용 전력(을) 고압A 선택II',
  '일반용 전력(을) 고압A 선택III',
  '일반용 전력(을) 고압B 선택I',
  '일반용 전력(을) 고압B 선택II',
  '일반용 전력(을) 고압B 선택III',
  '일반용 전력(을) 고압C 선택I',
  '일반용 전력(을) 고압C 선택II',
  '일반용 전력(을) 고압C 선택III',
  '산업용 전력(을) 고압A 선택I',
  '산업용 전력(을) 고압A 선택II',
  '산업용 전력(을) 고압A 선택III',
  '산업용 전력(을) 고압B 선택I',
  '산업용 전력(을) 고압B 선택II',
  '산업용 전력(을) 고압B 선택III',
  '산업용 전력(을) 고압C 선택I',
  '산업용 전력(을) 고압C 선택II',
  '산업용 전력(을) 고압C 선택III',
  '전기차 고압 선택I',
  '전기차 고압 선택II',
  '전기차 고압 선택III',
  '전기차 고압 선택IV',
  '전기차 저압 선택I',
  '전기차 저압 선택II',
  '전기차 저압 선택III',
  '전기차 저압 선택IV',
]

export const KEPCOPlanTypeList = KEPCOPlanTypeStringList.map((v, i) => {
  return { _id: `${i}`, name: v }
})
